import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';

import { AnalyticsOverviewPage } from '@pages/analytics';
import { Skeleton, Stack } from '@shared/ui';
import { resolveAnalyticsMoveTabPath } from '@pages/analytics/ui/analytics-move-tabs';

export const Route = createFileRoute('/$locale/_authenticated/analytics-move/overview')({
  validateSearch: z.object({
    tab: z.string().optional(),
  }),
  beforeLoad: ({ params, search }) => {
    if (search.tab !== undefined) {
      // eslint-disable-next-line @typescript-eslint/only-throw-error
      throw redirect({
        to: resolveAnalyticsMoveTabPath(search.tab),
        params: { locale: params.locale },
      });
    }
  },
  component: AnalyticsOverviewRoute,
  pendingComponent: AnalyticsOverviewPending,
  pendingMs: 0,
  pendingMinMs: 0,
});

function AnalyticsOverviewRoute() {
  return <AnalyticsOverviewPage />;
}

function AnalyticsOverviewPending() {
  return (
    <Stack gap="md" data-testid="analytics-overview-pending">
      <Skeleton className="h-10 w-72" />
      <Skeleton className="h-10 w-56" />
      <div className="grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-3">
        {Array.from({ length: 6 }).map((_, index) => (
          <div key={`overview-pending-${String(index)}`} className="space-y-3">
            <Skeleton className="h-5 w-2/3" />
            <Skeleton className="h-56 w-full" />
          </div>
        ))}
      </div>
    </Stack>
  );
}
